module.exports = __webpack_public_path__ + "static/img/gif10.40e85ec2.gif";